// extracted by mini-css-extract-plugin
export default {"cardLogoSmall":"cc-card-image_cardLogoSmall__ffbfK"};